import { clearStoredSession, useAuth, useUser } from '@myosh/myosh-login';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getRequestedUsername } from '@/utils/requested-username';

// A launch from Viking names the user it expects; anyone else signed in here is signed out first.
export const useUsernameGuard = () => {
  const { search } = useLocation();
  const { state } = useUser();
  const { logout } = useAuth();

  const requestedUsername = getRequestedUsername(search)?.toLowerCase();
  const currentUsername = state.user?.preferred_username?.toLowerCase();
  const isWrongUser = Boolean(requestedUsername && currentUsername && requestedUsername !== currentUsername);

  useEffect(() => {
    if (isWrongUser) {
      void logout().finally(clearStoredSession);
    }
  }, [isWrongUser, logout]);

  return isWrongUser;
};
